import './Panels.style.scss'

export const SuccessPanel = (props) => {

    const defaultStyle = {}

    return(
        <div 
            id="success-summary"
            className="bcSummary successSummary" 
            style={Object.assign(defaultStyle,props.style ? props.style : {})}
        >
            <div className="row">
                <div className="has-success verticalCenter">
                    <i className="fa fa-check-circle fa-2x"/>
                </div>
                <div className="col-11">
                    {props.children}
                </div>
            </div>
            
        </div>
    )
}

export const ErrorPanel = (props) => {

    const defaultStyle = {}

    return(
        <div 
            id="error-summary"
            className="bcSummary errorSummary" 
            style={Object.assign(defaultStyle,props.style ? props.style : {})}
        >
            <div className="row">
                <div className="has-error verticalCenter">
                    <i className="fa fa-exclamation-circle fa-2x"></i>
                </div>
                <div className="col-11">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export const WarningPanel = (props) => { 
    const defaultStyle = {}

    return(
        <div 
            id="warning-summary"
            className="bcSummary warningSummary" 
            style={Object.assign(defaultStyle,props.style ? props.style : {})}
        >
            <div className="row">
                <div className="has-warning verticalCenter">
                    <i className="fa fa-exclamation-triangle fa-2x"></i>
                </div>
                <div className="col-11">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

export const InfoPanel = (props) => {
    const defaultStyle = {}

    return(
        <div 
            id="info-summary"
            className="bcSummary infoSummary" 
            style={Object.assign(defaultStyle,props.style ? props.style : {})}
        >
            <div className="row">
                <div className="verticalCenter" style={{color:"#0058a4"}}>
                    <i className="fa fa-exclamation-circle fa-2x"></i>
                </div>
                <div className="col-11">
                    {props.children}
                </div>
            </div>
        </div>
    )  
}

export const GrayAreaPanel = (props) => {
    return(
        <div 
            id="gray-summary"
            className="bcSummary" 
            style={Object.assign({},props.style ? props.style : {})}>
            <div className="row">
                <div className="col-11">
                    {props.children}
                </div>
            </div>
        </div>
    )  
}

export const BlankAreaPanel = (props) => {
    return(
        <div 
            id="gray-summary"
            className="bcSummary blank" 
            style={Object.assign({},props.style ? props.style : {})}>
            <div className="row">
                <div className="verticalCenter">
                    <i className="fa fa-exclamation-circle fa-2x"></i>
                </div>
                <div className="col-11">
                    {props.children}
                </div>
            </div>
        </div>
    )
}
